import {recursiveWalker} from "@/includes/parse_psd_data";
import {PARSED_FIELD_TYPES, PSD_LAYERS_DATA_TYPES} from "@/includes/parse_psd_data/constants";
import _ from "lodash";

export const extractLayersFromTree = tree => {
    const layers = []

    recursiveWalker(tree, node => {
        if (!PSD_LAYERS_DATA_TYPES.includes(node.type) || !node.visible) {
            return;
        }

        layers.push(node)
    })

    return layers
}

export const extractGroupsFromTree = tree => {
  const groups = []

  recursiveWalker(tree, node => {
    if (node.type !== PARSED_FIELD_TYPES.FOLDER || !node.visible) {
      return;
    }

    const { children, ...group } = node;

    groups.push(group);
  })

  return groups
}

export const filterLayersByTemplate = (layers, template) => layers.filter(layer => template.fields.find(field => field.uuid === layer.uuid))

export const multipleTemplateHandler = (callback, postHandler) => async ({ files, options }) => {
    const _files = Array.isArray(files) ? files : [files];

    const promises = [];

    for (const file of _files) {
        for (const template of file.templates) {
            promises.push(async () => {
                const data = {
                    ...file,
                    template,
                    layers: !file.isImportWithoutLayers
                      ? filterLayersByTemplate(file.layers, { fields: extractLayersFromTree(template.children) })
                      : file.layers,
                    groups: file.isGroupGroupedLayers ? extractGroupsFromTree(template.children) : [],
                };

                return callback(data);
            });
        }
    }

    const chunks = _.chunk(promises, 1);

    for (const chunk of chunks) {
        await Promise.all(chunk.map(fn => fn()));
    }

    postHandler(options)
}

export const getOptionsFromLibraryModal = () => {
    let options = {}

    try {
        options = JSON.parse($('#selectBkImgModal').data('options'))
    } catch (error) {
        console.error('No options in file browser modal provided')
    }

    return options
}
